import React from 'react';
import { Alert, Box, Stack, ThemeProvider } from '@mui/material';
import { BirdzTitle } from '@applications-terrains/birdz-react-library';
import { useTranslation } from 'react-i18next';
import PagePaper from '../../../Tools/Pages/PagePaper';
import { useGetClientOssCode } from '../../../../hooks/datarefs';
import {
  InterventionCreationContextProvider,
  useInterventionCreation
} from './context/interventionCreationContext';
import ClientSelector from './ClientSelector';
import CreationStepper from './CreationStepper';
import RequestsStep from './Steps/Requests/RequestsStep';
import AssignmentStep from './Steps/Assignment/AssignmentStep';
import { createInterventionCreationTheme } from './theme';

function InterventionCreationContent() {
  const { t } = useTranslation();
  const { isLoading } = useGetClientOssCode();
  const { state } = useInterventionCreation();

  return (
    // Titre et client vivent dans le bloc titre de `PagePaper` : il est rendu au-dessus
    // de son séparateur et hors du conteneur qui défile, donc ils restent visibles en
    // permanence sans recourir à `position: sticky`.
    <PagePaper
      loader={isLoading}
      title={
        // `position: relative` + `zIndex` : la liste du client s'ouvre sans portail,
        // elle doit passer au-dessus du contenu qui la suit dans le DOM.
        <Box sx={{ position: 'relative', zIndex: 1 }}>
          {/* Côte à côte et alignés à gauche : pas de `justifyContent`, qui pousserait
              le sélecteur à l'opposé du titre. Repli en colonne sur petit écran. */}
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            alignItems={{ xs: 'flex-start', sm: 'center' }}
          >
            <BirdzTitle className="m-0">{t('interventionCreation.title')}</BirdzTitle>
            {/* Le sélecteur n'a qu'une largeur maximale : sur une ligne partagée, il
                lui faut une largeur explicite pour ne pas être réduit à son contenu. */}
            <Box sx={{ flexShrink: 0, width: { xs: '100%', sm: 320 } }}>
              <ClientSelector />
            </Box>
          </Stack>
        </Box>
      }
    >
      <Stack spacing={3}>
        {/* Le bandeau de reprise (`ResumeBanner`) n'est pas monté : sa mise en œuvre
            est reportée après la prochaine version. Le composant reste en place. */}
        <CreationStepper />

        {state.clientId === null ? (
          <Alert severity="info">{t('interventionCreation.selectClientFirst')}</Alert>
        ) : state.currentStep === 'requests' ? (
          <RequestsStep />
        ) : (
          <AssignmentStep />
        )}
      </Stack>
    </PagePaper>
  );
}

export default function InterventionCreationPage() {
  return (
    // Le design system ne s'applique qu'à cet écran : le ThemeProvider imbriqué
    // étend le thème parent au lieu de le remplacer.
    <ThemeProvider theme={createInterventionCreationTheme}>
      <InterventionCreationContextProvider>
        <InterventionCreationContent />
      </InterventionCreationContextProvider>
    </ThemeProvider>
  );
}
